import React from "react";

/** Inline: **bold**, *italic*, `code` */
export const renderInline = (text: string, keyPrefix: string): React.ReactNode[] => {
    const nodes: React.ReactNode[] = [];
    const re = /(\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`)/g;
    let last = 0;
    let match: RegExpExecArray | null;
    let i = 0;

    while ((match = re.exec(text)) !== null) {
        if (match.index > last) {
            nodes.push(text.slice(last, match.index));
        }
        const token = match[0];
        const key = `${keyPrefix}-${i++}`;
        if (token.startsWith("**")) {
            nodes.push(<strong key={key}>{token.slice(2, -2)}</strong>);
        } else if (token.startsWith("*")) {
            nodes.push(<em key={key}>{token.slice(1, -1)}</em>);
        } else {
            nodes.push(
                <code
                    key={key}
                    className="rounded bg-slate-100/90 px-1 py-0.5"
                >
                    {token.slice(1, -1)}
                </code>
            );
        }
        last = match.index + token.length;
    }
    if (last < text.length) nodes.push(text.slice(last));
    return nodes;
};
